<template>

    <div class="outer-wrapper">

        <div v-if=" inAppMsgs.length < 1 " class="nothing-loaded-wrapper">

            No Messages!
        </div>
        <div v-else>

            <div class="outer-msg" v-for=" ( msg, msgKey ) in inAppMsgs " :key=" msgKey ">

                <div class="inner-msg" @click=" openMsg( msg ) ">

                    <div class="description-wrapper">

                        <font-awesome-icon class="message-icon" :icon=" msg.Message.read ? 'envelope-open' : 'envelope' " />
                        <div class="text-wrapper">

                            <p class="title">{{ msg.Message.title }}</p>
                            <p class="excerpt">{{ msg.Message.text.substring( 0, 50 ) + '...' }}</p>
                        </div>
                    </div>
                    <div class="date-wrapper">

                        <p class="date">{{ formattedDate( msg.Message.created ) }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapGetters } from 'vuex';
    import FontAwesomeIcon from '@fortawesome/vue-fontawesome';

    export default {

        name: 'in-app-msg',
        computed: {

            ...mapGetters({

                inAppMsgs : 'inAppMsg/inAppMsgs',
                isLoading : 'isLoading'
            })
        },
        methods: {

            openMsg( msg ){

                this.$store.dispatch( 'inAppMsg/openMsg', msg );
            },
            formattedDate( date ){

                let newDate = date.split( ' ' );
                let calendar = newDate[ 0 ].split( '-' );
                let formattedCalendar = [ calendar[ 1 ], calendar[ 2 ], calendar[ 0 ] ].join( '/' );

                newDate[ 0 ] = formattedCalendar;
                newDate = newDate.join( ' ' );

                return new Date( String( newDate ) ).toLocaleString( 'en-US' );
            },
        },
        created(){

            this.$store.dispatch( 'inAppMsg/getMsgs' );
        },
        components: {

            FontAwesomeIcon
        }
    }
</script>

<style scoped>

    .outer-wrapper {

        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0 auto;

        padding-top: 0 !important;
        max-width: 450px;
    }

    .outer-msg {

        display: flex;
        align-items: center;

        padding: 5px;
        height: 140px;
        margin-bottom: 10px;
        background-color: white;
        font-family: Arial, Helvetica, sans-serif;
        box-shadow: 0px 3px 8px 0px rgba( 0, 0, 0, 0.5 );
    }
    .inner-msg {

        display: flex;
        flex-direction: column;
        justify-content: space-between;

        cursor: pointer;
        position: relative;
        height: 100%;
        width: 100%;
        padding: 0px 10px;
    }

    .description-wrapper {

        display: flex;
        justify-content: space-between;
        align-items: center;
        flex: 3;
    }

    .message-icon {

        font-size: 40px;
    }

    .text-wrapper {

        width: 100%;
        padding-left: 25px;
    }
    .title {

        font-weight: bold;
        font-size: 18px;
    }
    .excerpt {

        font-size: 14px;
    }

    .date-wrapper {

        flex: 1;
        font-size: 18px;
        text-align: right;
        position: relative;
        margin: auto 0 0 auto;
        color: #777;
        max-height: 25px;
    }

</style>